import React from "react";
import { useNotifications } from "../../context/notificationContext";
import Notification from "./Notification";

const NotificationsList: React.FC = () => {
  const { notifications } = useNotifications();

  return (
    <div className="notifications-list fixed top-10 right-10 w-96 z-50 space-y-4">
      {notifications.map((notification) => (
        <Notification key={notification.id} id={notification.id} title={notification.title} message={notification.message} type={notification.type} />
      ))}
    </div>
  );
};

export default NotificationsList;
